import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  menuSuperior: {
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  menuPesquisa: {
    display: 'flex',
    flexDirection: 'row',
  },
  inputPesquisa: {
    width: '60%',
    marginRight: '15px',
  },
}))

export default useStyles
